import { RouletteContainer } from "./RouletteContainer";

export class Pin extends Phaser.GameObjects.Container {

    private i: number;
    private glow: Phaser.GameObjects.Image;
    private glowTweening: boolean;
    private rouletteContainer: RouletteContainer;
    private pin: Phaser.GameObjects.Image;
    private showingPrize: boolean;

    constructor(scene: Phaser.Scene, rouletteContainer: RouletteContainer, i: number) {
        
        super(scene);

        this.i = i;
        this.rouletteContainer = rouletteContainer;
        this.showingPrize = false;

        const angle =  2* Math.PI / 20 * this.i;

        this.x = 488 * Math.cos(angle);
        this.y = 488 * Math.sin(angle);

        this.glowTweening = false;

        this.pin = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "pin");
        this.add(this.pin);

        this.glow = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "pin-glow");
        this.glow.visible = false;
        this.add(this.glow);
    }

    public update(): void {

        if (this.showingPrize) {
            this.visible = false;
            return;
        }

        const f = this.rouletteContainer.f1;

        if (this.rouletteContainer.spinning) {

            if (f % 20 === 0 && this.i % 2 !== 0) {
                this.activate();
            }

        } else {

            if (Math.floor(f / 4) === this.i && !this.glowTweening && !this.rouletteContainer.spinning) {

                this.activate();
            }
        }
    }

    public onPrizeShown(): void {

        this.showingPrize = true;
        this.pin.tint = 0xCCCCCC;
    }

    private activate(): void {

        let scale = this.rouletteContainer.spinning ? 5.5 : 4;

        this.glowTweening = true;
    
        this.glow.visible = true;
        this.glow.setScale(0);

        this.scene.add.tween({
            targets: this.glow,
            scaleX: scale,
            scaleY: scale,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 100,
            yoyo: true,
            onComplete: function(): void {
                this.glowTweening = false;
            },
            onCompleteScope: this
        });
    }
}
